import { SERVER_URL } from '../config'

import { pdfjs } from 'react-pdf'

pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString()

export const serverFile = (fileName: string) => {
    return fileName && `${SERVER_URL}/file/${fileName}`
}
